import { render } from "./bookmarkSearch.vue?vue&type=template&id=171b0e5d&scoped=true"
import script from "./bookmarkSearch.vue?vue&type=script&lang=js"
export * from "./bookmarkSearch.vue?vue&type=script&lang=js"

import "./bookmarkSearch.vue?vue&type=style&index=0&id=171b0e5d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-171b0e5d"

export default script